module.exports = __webpack_public_path__ + "media/images/site/step-two-b7521b8847faa6af77e4d5916654267e.svg";